import { registerApplication, start } from 'single-spa'
import { createStore } from 'redux'
import rootReducer from './Main/Reducers'
import FetchIntercept from './refactory/kernel/fetch-intercept'
import i18n from './config/i18n'

const store = createStore(rootReducer)
FetchIntercept(store, i18n)

registerApplication(
  'root',
  () => import('./root.app.js'),
  () => true,
  { store }
)

start()
